import { HomeIcon } from 'asterX-UI/Icons/HomeIcon'
import { RopInfo } from '../../RopInfo/RopInfo'
import { WlList } from '../../WlList/WlList'
import { TasksList } from '../../TasksList/TasksList'
import BonusesTab from '../../../../../../Desktop/Home/Manager/components/Bonuses/BonusesTab'

export const ropTabsList = [
  {
    icon: HomeIcon,
    component: RopInfo
  },
  {
    label: 'РЛ',
    component: WlList
  },
  {
    label: 'Задачи',
    component: TasksList
  },
  { label: 'Бонусы', component: BonusesTab }
]
